require('../cleave-add-on-in.js');
import Cleave from '../cleave-min.js';

$(document).ready(function() {

    $('.js-phone-no-input').toArray().forEach(function(field){
        new Cleave(field, {
            phone: true,
            phoneRegionCode: 'IN'
        });
     });

     $('.js-otp-input').toArray().forEach(function(field){
        new Cleave(field, {
            numericOnly: true
        });
     });

});
